<template>
    <div class="us_app">
        <section class="user_section">
            <div class="title jc">
                <h2>내 정보</h2>
            </div>
                                  
            <article class="view">
                <!-- 회원 정보 -->
                    <div class="table_list">
                        <h3 class="tb_title">회원 정보</h3>
                        <table class="write">
                            <colgroup>
                                <col width="200">
                                <col width="30%">
                                <col width="200">
                                <col width="30%">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th><span>로그인 ID</span></th>
                                    <td colspan="3">{{myInfo.login_id}}</td>                                   
                                </tr>
                                <tr>
                                    <th><span class="emp">이름</span></th>
                                    <td>{{myInfo.doctor_nm}}</td>
                                    <th><span class="emp">닉네임</span></th>
                                    <td><input type="text" class="form_control" v-model="myInfo.nick_nm" ></td>                                
                                </tr>
                                <tr>
                                </tr>
                                <tr>
                                    <th><span class="emp">성별</span></th>
                                    <td>
                                        <div class="form_inline">
                                            <div class="form_radio">
                                                <input type="radio" id="man" name="radio1" value="M" v-model="myInfo.doctor_gender">
                                                <label for="man">남</label>
                                            </div>
                                            <div class="form_radio">
                                                <input type="radio" id="girl" name="radio1" value="F" v-model="myInfo.doctor_gender">
                                                <label for="girl">여</label>
                                            </div>
                                        </div>                                       
                                    </td>
                                    <th><span class="emp">생년월일</span></th>
                                    <td>
                                        <div class="form_select" style="gap: 10px">
                                            <b-form-select v-model="myInfo.doctor_birth_year" class="w100" @change="fn_updateBirthDays">
                                                <b-form-select-option :value="''">선택</b-form-select-option>
                                                <b-form-select-option v-for="birthYear in birthYearList" :key="birthYear" :value="birthYear">{{birthYear}}</b-form-select-option>
                                            </b-form-select>
                                            <b-form-select v-model="myInfo.doctor_birth_month" class="w100" @change="fn_updateBirthDays">
                                                <b-form-select-option :value="''">선택</b-form-select-option>
                                                <b-form-select-option v-for="birthMonth in birthMonthList" :key="birthMonth" :value="birthMonth">{{birthMonth}}</b-form-select-option>
                                            </b-form-select>
                                            <b-form-select v-model="myInfo.doctor_birth_day" class="w100">
                                                <b-form-select-option :value="''">선택</b-form-select-option>
                                                <b-form-select-option v-for="birthDay in birthDayList" :key="birthDay" :value="birthDay">{{birthDay}}</b-form-select-option>
                                            </b-form-select>
                                        </div> 
                                    </td>
                                </tr>
                                <tr>
                                    <th><span class="emp">면허 번호</span></th>
                                    <td><input type="text" class="form_control" maxlength="5" v-model="myInfo.doctor_license_num" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" ></td>
                                    <th><span >발급일자</span></th>
                                    <td><input type="text" class="form_control" v-model="myInfo.license_issuance_date"></td>
                                </tr>
                                <tr>
                                    <th><span class="emp">우편번호</span></th>
                                    <td>
                                        <div class="form_inline w100">
                                            <input type="text" class="form_control" v-model="myInfo.doctor_post_no" readonly>
                                            <button class="btn btn_md btn_darkbrown" @click="fn_postSearch('mbr')">주소 찾기</button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th><span class="emp">주소</span></th>
                                    <td><input type="text" class="form_control" v-model="myInfo.doctor_addr" readonly></td>
                                </tr>
                                <tr>
                                    <th><span>상세주소</span></th>
                                    <td><input type="text" class="form_control w100" v-model="myInfo.doctor_addr_dtl"></td>
                                    <td colspan="2"><span class="txt_info">나머지 주소를 입력해주세요.</span></td>                                    
                                </tr>
                                <tr>
                                    <th><span class="emp">휴대폰번호</span></th>
                                    <td>
                                        <div class="form_select form_inline">
                                            <b-form-select v-model="dispsrMbrCpNo1" class="w100">
                                                <b-form-select-option value="">선택</b-form-select-option>
                                                <b-form-select-option v-for="phonefixes in phonePrefixes" :key="phonefixes" :value="phonefixes">{{phonefixes}}</b-form-select-option>
                                            </b-form-select> -
                                            <input type="text" class="form_control" v-model="dispsrMbrCpNo2" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">-
                                            <input type="text" class="form_control" v-model="dispsrMbrCpNo3" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                                        </div>                                        
                                    </td>
                                    <th><span>문자 수신</span></th>
                                    <td>
                                        <div class="form_inline">
                                            <div class="form_radio">
                                                <input type="radio" id="mail1" name="radioMessage" value="Y" v-model="myInfo.doctor_phone_recv_yn">
                                                <label for="mail1">수신</label>
                                            </div>
                                            <div class="form_radio">
                                                <input type="radio" id="mail2" name="radioMessage" value="N" v-model="myInfo.doctor_phone_recv_yn">
                                                <label for="mail2">수신하지 않음</label>
                                            </div>
                                        </div>                                       
                                    </td>
                                </tr>
                                <tr>
                                    <th><span>전화번호</span></th>
                                    <td>
                                         <div class="form_select form_inline">
                                            <b-form-select v-model="dispsrMbrTelNo1" class="w100">
                                                <b-form-select-option :value="''">선택</b-form-select-option>
                                                <b-form-select-option v-for="areaCode in telAreaCodes" :key="areaCode" :value="areaCode">{{areaCode}}</b-form-select-option>
                                            </b-form-select> -
                                            <input type="text" class="form_control" v-model="dispsrMbrTelNo2" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">-
                                            <input type="text" class="form_control" v-model="dispsrMbrTelNo3" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                                        </div>     
                                    </td>
                                </tr>
                                <tr>
                                    <th><span>이메일</span></th>
                                    <td>
                                         <div class="form_select form_inline">
                                            <input type="text" class="form_control" v-model="doctor_mail">@
                                            <input type="text" class="form_control" v-model="doctor_mail_domain" :readonly="doctor_select_domain !== ''">
                                            <b-form-select v-model="doctor_select_domain" class="w100" @change="fn_change_mail_domain">
                                                <b-form-select-option :value="''">직접 입력</b-form-select-option>
                                                <b-form-select-option v-for="domain in mailDomain" :key="domain" :value="domain">{{domain}}</b-form-select-option>
                                            </b-form-select> 
                                        </div>     
                                    </td>
                                    <th><span>메일 수신</span></th>
                                    <td>
                                        <div class="form_inline">
                                            <div class="form_radio">
                                                <input type="radio" id="mail1" name="radioMail" value="Y" v-model="myInfo.doctor_email_recv_yn">
                                                <label for="mail1">수신</label>
                                            </div>
                                            <div class="form_radio">
                                                <input type="radio" id="mail2" name="radioMail" value="N" v-model="myInfo.doctor_email_recv_yn">
                                                <label for="mail2">수신하지 않음</label>
                                            </div>
                                        </div>                                       
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- 한의원 정보 -->
                    <div class="table_list" v-show="myInfo.clinic_doctor_class == 'C'">
                        <h3 class="tb_title">한의원 정보</h3>
                        <table class="write">
                            <colgroup>
                                <col width="200">
                                <col width="30%">
                                <col width="200">
                                <col width="30%">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th><span class="emp">한의원 명</span></th>
                                    <td><input type="text" class="form_control" v-model="myInfo.clinic_nm"></td>
                                </tr>
                                <tr>
                                    <th><span class="emp">사업자번호</span></th>
                                    <td>
                                        <div class="form_inline">
                                            {{bizRegNum1}} - {{bizRegNum2}} - {{bizRegNum3}}
                                        </div>
                                    </td>                                    
                                </tr>
                                <tr>
                                    <th><span class="emp">우편번호</span></th>
                                    <td>
                                        <div class="form_inline w100">
                                            <input type="text" class="form_control" v-model="myInfo.clinic_post_no">
                                            <button class="btn btn_md btn_darkbrown" @click="fn_postSearch('clinc')">주소 찾기</button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th><span class="emp">주소</span></th>
                                    <td><input type="text" class="form_control" v-model="myInfo.clinic_addr"></td>
                                </tr>
                                <tr>
                                    <th><span>상세주소</span></th>
                                    <td><input type="text" class="form_control" v-model="myInfo.clinic_addr_dtl"></td>
                                    <td colspan="2"><span class="txt_info ">나머지 주소를 입력해주세요.</span></td>                                    
                                </tr>
                                <tr>
                                    <th><span>전화번호</span></th>
                                    <td>
                                         <div class="form_select form_inline">
                                            <b-form-select v-model="orintMedclClincTelNo1" class="w100">
                                                <b-form-select-option :value="''">선택</b-form-select-option>
                                                <b-form-select-option v-for="areaCode in telAreaCodes" :key="areaCode" :value="areaCode">{{areaCode}}</b-form-select-option>
                                            </b-form-select> -
                                            <input type="text" class="form_control" v-model="orintMedclClincTelNo2" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">-
                                            <input type="text" class="form_control" v-model="orintMedclClincTelNo3" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                                        </div>     
                                    </td>
                                    <th><span>팩스번호</span></th>
                                    <td>
                                        <div class="form_select form_inline">
                                            <b-form-select v-model="orintMedclClincFaxNo1" class="w100">
                                                <b-form-select-option :value="''">선택</b-form-select-option>
                                                <b-form-select-option v-for="areaCode in telAreaCodes" :key="areaCode" :value="areaCode">{{areaCode}}</b-form-select-option>
                                            </b-form-select> -
                                            <input type="text" class="form_control" v-model="orintMedclClincFaxNo2" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">-
                                            <input type="text" class="form_control" v-model="orintMedclClincFaxNo3" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                                        </div>     
                                    </td>
                                </tr>
                                <tr>
                                    <th><span class="emp">실무자 성함</span></th>
                                    <td><input type="text" class="form_control" v-model="myInfo.clinic_official_nm"></td>
                                    <th><span>직책</span></th>
                                    <td><input type="text" class="form_control" v-model="myInfo.clinic_official_position"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="bottom_box bn">
                        <button 
                            class="btn btn_md btn_brown btn_outline"
                            @click="fn_move_main"
                        >
                            취소
                        </button>
                        <button 
                            class="btn btn_md btn_brown"
                            @click="fn_save()"
                        >
                            정보수정
                        </button>
                    </div>   
            </article>
            <alert-modal 
                        :id="'alert'"
                        :text="showAlertMsg" 
                        :btnRight="'확인'" 
                        :oneBtn="false"
                        :isShow="showAlert"
                        :className="'btn_brown'"
                        v-on:update:showSetting="fn_showSet"
                    />
                       
        </section>
    </div>
</template>

<script>
    import axios from 'axios'
    import commonUtil from "@/mixin/commonUtil";
    import AlertModal from "@/modal/common/alertModal.vue"
    import alertutill from "@/mixin/alertModalUtill";

    export default {
        components: {
            'alert-modal' : AlertModal,
        },
        mixins: [commonUtil,alertutill],
        data () {
            return {
                birthYearList : [],
                birthMonthList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
                birthDayList : [],
                phonePrefixes: ['010', '011', '016', '017', '018', '019'],
                dispsrMbrCpNo1 : '',
                dispsrMbrCpNo2 : '',
                dispsrMbrCpNo3 : '',
                telAreaCodes: [
                                '02',   // 서울
                                '031', '032', '033', // 경기, 인천, 강원
                                '041', '042', '043', // 충청
                                '051', '052', '053', '054', '055', // 경상
                                '061', '062', '063', // 전라
                                '064'  // 제주
                            ],
                dispsrMbrTelNo1 : '',
                dispsrMbrTelNo2 : '',
                dispsrMbrTelNo3 : '',
                mailDomain: ['gmail.com', 'naver.com', 'daum.net', 'hanmail.net', 'hotmail.com'],
                doctor_mail : '',
                doctor_mail_domain : '',
                doctor_select_domain : '',
                orintMedclClincTelNo1 : '',
                orintMedclClincTelNo2 : '',
                orintMedclClincTelNo3 : '',
                orintMedclClincFaxNo1 : '',
                orintMedclClincFaxNo2 : '',
                orintMedclClincFaxNo3 : '',
                bizRegNum1 : '',
                bizRegNum2 : '',
                bizRegNum3 : '',
                myInfo : {
                    clinic_doctor_id : '',
                    doctor_nm : '',
                    nick_nm : '',
                    clinic_doctor_class : '',
                    doctor_gender : 'M',
                    doctor_birth_year : '',
                    doctor_birth_month : '',
                    doctor_birth_day : '',
                    doctor_post_no : '',
                    doctor_addr : '',
                    doctor_addr_dtl : '',
                    doctor_phone_num : '',
                    doctor_tel_num : '',
                    doctor_email : '',
                    doctor_phone_recv_yn : 'Y',
                    doctor_email_recv_yn : 'Y',
                    doctor_license_num : '',
                    license_issuance_date : '',
                    clinic_nm : '',
                    clinic_business_num : '',                    
                    clinic_post_no : '',
                    clinic_addr : '',
                    clinic_addr_dtl : '',
                    clinic_tel_num : '',
                    clinic_fax_num : '',  
                    clinic_official_nm : '',
                    clinic_official_position : ''
                },
            }
        },
        created(){

            //생년월일 년도 구하기 
            const currentYear = new Date().getFullYear();
            const startCentury = Math.floor((currentYear - 100) / 100) * 100;
            for (let y = currentYear; y >= startCentury; y--) {
                this.birthYearList.push(y)
            }
        },
        mounted() {
            this.fn_search();
        },
        methods : {
            fn_search(){

                let param = new Object();
                param.clinicDoctorId = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];

                axios
                    .post("/api/user/mypage/getMyinfo", param)
                    .then((res) => {

                        this.myInfo = res.data.myInfo;

                        let splitNumbeObj = this.splitPhoneNumber(this.myInfo.doctor_phone_num);

                        this.dispsrMbrCpNo1 = splitNumbeObj[0];
                        this.dispsrMbrCpNo2 = splitNumbeObj[1];
                        this.dispsrMbrCpNo3 = splitNumbeObj[2];

                        if(this.myInfo.doctor_tel_num != null && this.myInfo.doctor_tel_num !=''){
                            let splitNumbeObj = this.splitPhoneNumber(this.myInfo.doctor_tel_num);

                            this.dispsrMbrTelNo1 = splitNumbeObj[0];
                            this.dispsrMbrTelNo2 = splitNumbeObj[1];
                            this.dispsrMbrTelNo3 = splitNumbeObj[2];
                        }   
                        
                        // 날짜셋팅
                        this.fn_updateBirthDays();

                        //메일 셋팅
                        if(this.myInfo.doctor_email != null && this.myInfo.doctor_email !=''){
                            let splitMailAddr = this.splitEmail(this.myInfo.doctor_email);

                            this.doctor_mail = splitMailAddr[0];
                            this.doctor_mail_domain = splitMailAddr[1];
                            this.doctor_select_domain = splitMailAddr[1];
                        }

                        if(this.myInfo.clinic_business_num != null){
                            let splitBizNumObj = this.splitBizNumber(this.myInfo.clinic_business_num);

                            this.bizRegNum1 = splitBizNumObj[0];
                            this.bizRegNum2 = splitBizNumObj[1];
                            this.bizRegNum3 = splitBizNumObj[2];
                        }
                        
                        if(this.myInfo.clinic_tel_num != null && this.myInfo.clinic_tel_num !=''){
                            let splitNumberObj = this.splitPhoneNumber(this.myInfo.doctor_tel_num);

                            this.orintMedclClincTelNo1 = splitNumberObj[0];
                            this.orintMedclClincTelNo2 = splitNumberObj[1];
                            this.orintMedclClincTelNo3 = splitNumberObj[2];
                        } 

                        if(this.myInfo.clinic_fax_num != null && this.myInfo.clinic_fax_num !=''){
                            let splitNumberObj = this.splitPhoneNumber(this.myInfo.doctor_tel_num);

                            this.orintMedclClincFaxNo1 = splitNumberObj[0];
                            this.orintMedclClincFaxNo2 = splitNumberObj[1];
                            this.orintMedclClincFaxNo3 = splitNumberObj[2];
                        } 
                        
                    })
                    .catch((err) => console.log(err));
            },
            fn_updateBirthDays() {
                //생년월일 날짜 계산
                if (!this.myInfo.doctor_birth_year || !this.myInfo.doctor_birth_month) {
                    this.birthDayList = []
                    return
                }

                const year = parseInt(this.myInfo.doctor_birth_year)
                const month = parseInt(this.myInfo.doctor_birth_month)
                const daysInMonth = new Date(year, month, 0).getDate()

                this.days = []
                for (let d = 1; d <= daysInMonth; d++) {
                    this.birthDayList.push(d)
                }

                // 선택한 날짜가 현재 달에 없는 경우 초기화
                if (this.myInfo.doctor_birth_day > daysInMonth) {
                    this.myInfo.doctor_birth_day = ''
                }
            },
            fn_updateBirthDays() {
                //생년월일 날짜 계산
                if (!this.myInfo.doctor_birth_year || !this.myInfo.doctor_birth_month) {
                    this.birthDayList = []
                    return
                }

                const year = parseInt(this.myInfo.doctor_birth_year)
                const month = parseInt(this.myInfo.doctor_birth_month)
                const daysInMonth = new Date(year, month, 0).getDate()

                this.days = []
                for (let d = 1; d <= daysInMonth; d++) {
                    this.birthDayList.push(d)
                }

                // 선택한 날짜가 현재 달에 없는 경우 초기화
                if (this.myInfo.doctor_birth_day > daysInMonth) {
                    this.myInfo.doctor_birth_day = ''
                }
            },
            fn_change_mail_domain(){
                if(this.doctor_select_domain == null || this.doctor_select_domain == ''){
                    this.doctor_mail_domain = '';
                }else{
                    this.doctor_mail_domain = this.doctor_select_domain;
                }
            },
            callBackAddr(call,postInfo){
                
                console.log("@@@@ postInfo : %o",postInfo);

                if(call == 'mbr'){
                    this.myInfo.doctor_post_no = postInfo.zonecode;
                    this.myInfo.doctor_addr = postInfo.roadAddress;
                }else if(call == 'clinc'){
                    this.myInfo.clinic_post_no = postInfo.zonecode;
                    this.myInfo.clinic_addr = postInfo.roadAddress;
                }
            },
            fn_validation_chk(){
                
                // console.log("validation chk")

                let msg = "";

                if(this.myInfo.dispsrMbrNm == ''){
                    msg = "이름을 입력해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }

                if(this.myInfo.doctor_birth_year == ''){
                    msg = "생년월일의 년도를 입력해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }else if(this.myInfo.doctor_birth_month == ''){
                    msg = "생년월일의 월을 입력해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }else if(this.myInfo.dispsrMbrBirthDay == ''){
                    msg = "생년월일의 날짜를 입력해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }

                if(this.myInfo.doctor_post_no == '' || this.myInfo.doctor_addr == ''){
                    msg = "주소검색을 해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }

                if(this.dispsrMbrCpNo1 == '' || this.dispsrMbrCpNo2 == '' || this.dispsrMbrCpNo3 == ''){
                    msg = "휴대전화번호를 입력해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }else if(this.dispsrMbrCpNo2.length < 3 && this.dispsrMbrCpNo2.length > 4){
                    msg = "잘못된 휴대전화번호입니다.";
                    this.fn_open_alert(msg);    
                    return false;
                }else if(this.dispsrMbrCpNo3.length != 4){
                    msg = "잘못된 휴대전화번호입니다.";
                    this.fn_open_alert(msg);    
                    return false;
                }else{
                    this.myInfo.doctor_phone_num = this.dispsrMbrCpNo1.toString()+this.dispsrMbrCpNo2.toString()+this.dispsrMbrCpNo3.toString();
                }


                if(this.dispsrMbrTelNo1 && typeof this.dispsrMbrTelNo1 === 'string' && this.dispsrMbrTelNo1.trim() !== ''){
                    
                    if(this.dispsrMbrTelNo2.length < 3 || this.dispsrMbrTelNo2.length > 4){
                        msg = "잘못된 전화번호입니다.";
                        this.fn_open_alert(msg);    
                        return false;
                    }
                    if(this.dispsrMbrTelNo3.length != 4 ){
                        msg = "잘못된 전화번호입니다.";
                        this.fn_open_alert(msg);    
                        return false;
                    }

                    this.myInfo.doctor_tel_num = this.dispsrMbrTelNo1.toString()+this.dispsrMbrTelNo2.toString()+this.dispsrMbrTelNo3.toString();
                    
                }else{
                    this.dispsrMbrTelNo2 = '';
                    this.dispsrMbrTelNo3 = '';
                }

                if(this.doctor_mail != '' || this.doctor_mail_domain != ''){
                    if(this.doctor_mail == ''){
                        msg = "Email ID를 입력해주세요";
                        this.fn_open_alert(msg);    
                        return false;
                    }else if(this.doctor_mail_domain == ''){
                        msg = "Email 정보를 입력해주세요";
                        this.fn_open_alert(msg);    
                        return false;
                    }

                    this.myInfo.doctor_email = this.doctor_mail + '@' + this.doctor_mail_domain;
                }



                //한의원 등록인 경우
                if(this.myInfo.clinic_doctor_class == 'C'){
                    if(this.myInfo.orintMedclClincNm == ''){
                        msg = "한의원명을 입력해주세요";
                        this.fn_open_alert(msg);    
                        return false;
                    }

                    if(this.myInfo.clinic_post_no == '' || this.myInfo.clinic_addr == ''){
                        msg = "한의원 주소검색을 해주세요";
                        this.fn_open_alert(msg);    
                        return false;
                    }
                    

                    if(this.orintMedclClincTelNo1 && typeof this.orintMedclClincTelNo1 === 'string' && this.orintMedclClincTelNo1.trim() !== ''){
                    
                        if(this.orintMedclClincTelNo2.length < 3 || this.orintMedclClincTelNo2.length > 4){
                            msg = "잘못된 전화번호입니다.";
                            this.fn_open_alert(msg);    
                            return false;
                        }
                        if(this.orintMedclClincTelNo3.length != 4 ){
                            msg = "잘못된 전화번호입니다.";
                            this.fn_open_alert(msg);    
                            return false;
                        }

                        this.myInfo.clinic_tel_num = this.orintMedclClincTelNo1.toString()+this.orintMedclClincTelNo2.toString()+this.orintMedclClincTelNo3.toString();
                        
                    }else{
                        this.orintMedclClincTelNo2 = '';
                        this.orintMedclClincTelNo3 = '';
                    }

                    if(this.orintMedclClincFaxNo1 && typeof this.orintMedclClincFaxNo1 === 'string' && this.orintMedclClincFaxNo1.trim() !== ''){
                    
                        if(this.orintMedclClincFaxNo2.length < 3 || this.orintMedclClincFaxNo2.length > 4){
                            msg = "잘못된 팩스 전화번호입니다.";
                            this.fn_open_alert(msg);    
                            return false;
                        }
                        if(this.orintMedclClincFaxNo3.length != 4 ){
                            msg = "잘못된 팩스 전화번호입니다.";
                            this.fn_open_alert(msg);    
                            return false;
                        }

                        this.myInfo.clinic_fax_num = this.orintMedclClincFaxNo1.toString()+this.orintMedclClincFaxNo2.toString()+this.orintMedclClincFaxNo3.toString();
                        
                    }else{
                        this.orintMedclClincFaxNo2 = '';
                        this.orintMedclClincFaxNo3 = '';
                    }

                    if(this.myInfo.clinic_official_nm == ''){
                        msg = "실무자명을 입력해주세요";
                        this.fn_open_alert(msg);    
                        return false;
                    }
                }

                return true;
            },
            fn_move_main(){
                this.$router.push("/");
            },
            fn_save(){

                if(this.fn_validation_chk()){
                    axios
                    .post("/api/user/mypage/modMyInfo", this.myInfo)
                    .then((res) => {                            
                        console.log("@@@@ res : %o",res);

                        if(res.data.result == 'ok'){

                            console.log("@@@@ res : ok");

                            let msg = "회원정보 수정이 완료되었습니다.";
                            this.fn_open_alert(msg);  

                        }
                        
                    })
                    .catch((err) => console.log(err));
                }
            }
        }
    }
</script>